import { popEmeraldModal } from '../../common/emerald-modal-manager/emerald-modal-manager';
import { alertRaise } from '../../home-page/business-logic/service/alert-raise';
import { popupMessage } from '../../messages/business-logic/popup-message';
import { IAlertsState, showAlertDialog } from '../component/alerts';

export const popupAlerts = () => {
  const onAlertClick = (alertId: string): void => {
    alertRaise(alertId)
      .then(() => popEmeraldModal())
      .catch(popupMessage);
  };

  const alertsProps: IAlertsState = {
    onAlertClick,
    onClose: popEmeraldModal,
  };

  showAlertDialog(alertsProps);
};
